import {NgModule} from '@angular/core';
import {L10nModule} from '../translate';
import {CopyTxExploreTooltipBalloonComponent} from './copy-tx-explore-tooltip-balloon.component';
import {CopyTxExploreTooltipDirective} from './copy-tx-explore-tooltip.directive';

@NgModule({
    declarations: [
        CopyTxExploreTooltipBalloonComponent,
        CopyTxExploreTooltipDirective
    ],
    imports:      [
        L10nModule
    ],
    exports:      [
        CopyTxExploreTooltipDirective
    ]
})
export class CopyTxExploreTooltipModule {}
